import type { CartItem } from '@backmarket/nuxt-layer-checkout/api/cart/types'

/**
 * Determines whether to display low stock information for a cart item.
 *
 * @example
 * shouldShowStockInfo({ available: 'yes', quantityMax: 5 }) // true
 * shouldShowStockInfo({ available: 'yes', quantityMax: 50 }) // false
 * shouldShowStockInfo({ available: 'no', quantityMax: 5 }) // false
 */
export function shouldShowStockInfo(
  item: Pick<CartItem, 'available' | 'quantityMax'>,
): boolean {
  return (
    item.available === 'yes' && item.quantityMax > 0 && item.quantityMax < 10
  )
}
